<template>
  <v-container grid-list-md text-md-center>
    <v-flex v-if="isLoggedIn">حياك الله {{fullname}}, نشكرك مقدماً على المساعدة</v-flex>
    <v-flex v-else>
      <v-alert prominent type="error" value="true">
        <v-layout align-center wrap>
          <div mb2>الرجاء التسجيل أو تسجيل الدخول لإضافة بلاغ جديد</div>
          <v-spacer></v-spacer>
          <v-btn @click.stop="showLogin=true">تسجيل دخول</v-btn>
          <v-btn @click.stop="showRegisteration=true">تسجيل جديد</v-btn>
        </v-layout>
      </v-alert>
      <register v-model="showRegisteration"></register>
      <login v-model="showLogin"></login>
    </v-flex>
    <form>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-validate="'required|max:30'"
            v-model="missing.title"
            :counter="30"
            :error-messages="errors.collect('title')"
            label="العنوان"
            data-vv-name="title"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-checkbox v-model="isAward" label="هل يوجد مكافأة؟"></v-checkbox>
        </v-flex>
        <v-flex xs6 v-if="isAward">
          <v-text-field
            v-model="missing.award"
            :error-messages="errors.collect('award')"
            label="المكافأة"
            v-validate="'number'"
            data-vv-name="award"
            required
            prefix="ر.س"
            type="number"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-select
            xs6
            v-validate="'required'"
            :items="cities"
            item-text="name"
            item-value="id"
            v-model="missing.cityId"
            :error-messages="errors.collect('cityId')"
            label="المدينة"
            data-vv-name="cityId"
            required
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            xs6
            v-validate="'required'"
            :items="categories"
            item-text="name"
            item-value="id"
            v-model="missing.categoryId"
            :error-messages="errors.collect('categoryId')"
            label="التصنيف"
            data-vv-name="categoryId"
            required
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-textarea
            outline
            v-validate="'required'"
            name="description"
            v-model="missing.description"
            :error-messages="errors.collect('description')"
            data-vv-name="description"
            required
            rows="15"
            counter="4000"
            label="الوصف"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-checkbox v-model="isImages" label="هل يوجد صور؟"></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 v-if="isImages">
          <vue-dropzone
            :destroyDropzone="false"
            ref="myVueDropzone"
            id="dropzone"
            contenteditable="erer"
            :options="dropzoneOptions"
            @vdropzone-success="uploaded"
            @vdropzone-removed-file="deleted"
          ></vue-dropzone>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-checkbox v-model="isLocation" label="هل يوجد موقع؟"></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 v-if="isLocation">
          <maps-component @updateLocation="updateLocation"></maps-component>
        </v-flex>
      </v-layout>
      <v-btn color="success" @click="submit" :disabled="!isLoggedIn">إنشاء بلاغ</v-btn>
      <v-btn color="warning" ouline @click="clear">مسح</v-btn>
    </form>
  </v-container>
</template>
<script>
import Login from ".././components/account/Login";
import Register from ".././components/account/Register";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState, mapActions } from "vuex";
import { parseArabicNumbers } from "../helpers/helpers";
import { Endpoint } from "../config";
import MapsComponent from "../components/Common/MapsComponent";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    MapsComponent,
    Register,
    Login
  },
  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    showRegisteration: true,
    showLogin: false,
    isAward: false,
    isImages: false,
    isLocation: false,
    missing: {
      title: null,
      award: 0,
      categoryId: null,
      cityId: null,
      description: null,
      images: [],
      longitude: 0,
      latitude: 0
    },

    dictionary: {
      custom: {
        cityId: {
          required: () => "حقل المدينة إجباري"
          // custom messages
        },
        categoryId: {
          required: () => "حقل التصنيف إجباري"
          // custom messages
        },
        description: {
          required: () => "حقل الوصف إجباري"
          // custom messages
        },
        title: {
          required: () => "حقل العنوان إجباري",
          max: "أقصى عدد أحرف لحقل العنوان هو ٣٠"
          // custom messages
        }
      }
    },
    dropzoneOptions: {
      url: `${Endpoint}/api/image/upload`,
      headers: {
        "Cache-Control": null,
        "X-Requested-With": null,
        Authorization: "Bearer " + localStorage.getItem("token")
      },
      method: "POST",
      thumbnailWidth: 150,
      addRemoveLinks: true,
      acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
      maxFilesize: 2,
      resizeWidth: 650,
      resizeMimeType: "image/jpeg",
      resizeQuality: 0.5,
      dictDefaultMessage: "من فضلك أرفق الصور هنا"
    }
  }),
  computed: {
    ...mapState({
      cities: state => state.SearchStore.cities,
      categories: state => state.SearchStore.categories,
      isLoggedIn: state => state.AuthStore.user.token !== null,
      fullname: state => state.AuthStore.user.fullname
    })
  },
  mounted() {
    this.$validator.localize("ar", this.dictionary);
    this.getLookups();
  },

  methods: {
    ...mapActions(["getLookups", "toggleLoading", "toggleAlert"]),
    async submit() {
      var valid = await this.$validator.validateAll();
      if (valid) {
        this.missing.award = parseArabicNumbers(this.missing.award);
        this.toggleLoading();
        let _this = this;
        axios
          .post(`${Endpoint}/api/missing/create`, {
            ...this.missing
          })
          .then(response => {
            _this.$router.push({ name: "home" });
          })
          .catch(error => {
            this.toggleAlert(error.message);
          })
          .finally(() => {
            this.toggleLoading();
          });
      }
    },
    clear() {
      this.missing = {
        title: "",
        award: 0,
        categoryId: null,
        cityId: null,
        description: null,
        images: [],
        longitude: 0,
        latitude: 0
      };
      this.isLocation = false;
      this.isAward = false;
      this.isImages = false;
      this.$validator.reset();
    },
    uploaded(file, response) {
      file.id = response.imageId;
      this.missing.images.push(response.imageId);
    },
    deleted(file) {
      this.toggleLoading();
      axios.post(`${Endpoint}/api/image/Delete/${file.id}`);
      this.missing.images = this.missing.images.filter(function(value) {
        return value === file.id;
      });
      this.toggleLoading();
    },
    updateLocation(latitude, longitude) {
      this.missing.latitude = latitude;
      this.missing.longitude = longitude;
    }
  }
};
</script>
